import { render, staticRenderFns } from "./QRcode.vue?vue&type=template&id=42bb9dee&scoped=true&"
import script from "./QRcode.vue?vue&type=script&lang=js&"
export * from "./QRcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bb9dee",
  null
  
)

export default component.exports